module.exports = __webpack_public_path__ + "static/media/22-8.159a1dbf.mp3";